<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<meta charset="utf-8"/>
<link href="styles/custom.css" rel="stylesheet" type="text/css"/>
<title>Blood Before Dawn</title>
<section epub:type="acknowledgments">
<p class="ct1"><span epub:type="pagebreak" id="page_xi" title="xi">ACKNOWLEDGMENT</span></p>
<p class="tx1">To Caleb Guard, my editor, for his patience, understanding and professionalism and to Andrea Vande Vorde for her eye for detail.</p>
<p class="tx">I would also like to thank Jane Knuth of the The Knuth Agency for being a particularly thoughtful early reader and editor and to Teeja Meier, my wife, for her faith in me and for her love.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter03.vue?98c2c6c4